import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";

function Block11() {

    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content">
                <div className="auto-container">
                    <div className="row grid-base align-items-center g-5">
                        <div className="content-column -no-margin col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <div className="wow fadeInLeft">
                                <div className="sec-title">
                                    <h2 className="fw-700">Mesurez <span>l’impact réel</span> de vos actions</h2>
                                </div>

                                <div className="text mt-30">
                                    Pour aller au-delà de la simple diffusion de contenus,
                                    Talents Handicap vous fournit <b>des indicateurs clairs et exploitables</b> après chaque webinaire :
                                </div>
                                <ul className="list-style-two at-home19 homepage mt20">
                                    <li>Statistiques de participation (inscrits, présents, replay ...)</li>
                                    <li>Envoi de questionnaires de satisfaction aux participants</li>
                                    <li>Analyse des retours et du niveau de satisfaction</li>
                                    <li>Synthèse des enseignements clés</li>
                                    <li>Indicateurs utiles pour votre reporting interne et votre politique handicap</li>
                                </ul>
                                <ContactModal textButton="Échangeons sur vos besoins" showText={false} small="small" linkPageContact={false} iframe={false} couleur={false} formModal={true}/>
                            </div>
                        </div>

                        <div className="image-column col-xl-5 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <figure className="image-box image-responsive">
                                <img src="/images/resource/discussions1.webp" alt="discussions" className="homepage" />
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Block11;
